<template>
  <el-button v-bind="$attrs" v-on="$listeners" :icon="icon"
             :disabled="backing"
             @click="onClick">
    返回
  </el-button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "el-icon-arrow-left"
    },
    //是否返回上一步，默认true
    goBack: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      backing: false
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
      if (this.goBack) {
        this.backing = true;
        this.$router.back();
      }
    }
  }
}
</script>
